function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 54,
  height: 50,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("ellipse", {
  cx: 27.18,
  cy: 22.911,
  stroke: "#fff",
  strokeWidth: 2.652,
  rx: 20.698,
  ry: 20.911,
  style: {
    mixBlendMode: "screen"
  }
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2.922,
  d: "m2 48 25-25.257L52 48",
  style: {
    mixBlendMode: "screen"
  }
}));
export { SvgLogo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTQiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1NCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxlbGxpcHNlIGN4PSIyNy4xODA0IiBjeT0iMjIuOTExNCIgcng9IjIwLjY5ODUiIHJ5PSIyMC45MTE0IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIuNjUyMjkiIHN0eWxlPSJtaXgtYmxlbmQtbW9kZTpzY3JlZW4iLz4NCjxwYXRoIGQ9Ik0yIDQ4TDI3IDIyLjc0MjlMNTIgNDgiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMi45MjE2OSIgc3R5bGU9Im1peC1ibGVuZC1tb2RlOnNjcmVlbiIvPg0KPC9zdmc+DQo=";